import React, { Component } from 'react';
import { Row, Col } from "reactstrap";
import CardDetalheNotaFiscalFaturament from "../../../comum/components/CardDetalheNotaFiscalFaturament";
import LoadingImage from '../../../comum/components/LoadingImage';

export default class DetalhesNotaFiscalFaturamento extends Component {
    constructor(props) {
        super(props)
        this.state = { itens: [], notaId: this.props.notaId }
        this.controller = this.props.controller
    }

    componentDidMount() {
        if (this.state.notaId !== 0) {
            this.controller.getAnexos(this.state.notaId).then(itens => {
                this.setState({ itens: itens })
            })
        }
    }

    render() {
        const { colunasAnexosFaturamento: columns } = this.controller
        const { itens } = this.state
        return (
            <React.Fragment>
                {(itens && itens.length > 0) ?
                    itens.map((row, x) => (
                        <Col xl={"auto"} lg={3} className="m-0 mb-2 mr-2 card-detalhe-anexos anexos" key={x}>
                            {
                                columns.map((el, x) => {
                                    return (
                                        <Row key={x}>
                                            <CardDetalheNotaFiscalFaturament titulo={el.titulo}
                                                label={el.label}
                                                desc={el.field.map((field) => row[field])}
                                                formatacao={el.formatacao}
                                                protocoloId={row.Id}
                                                link={row.Link}
                                                downloadFile={this.controller.downloadFileSaver}
                                            />
                                        </Row>
                                    )
                                })
                            }
                        </Col>)
                    )
                    : <LoadingImage />}
            </React.Fragment>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/notafiscal/components/DetalhesNotaFiscalFaturamento.js